<div>

    <div class="buttons" data-qa="settings-schaltleitungen-page-button">
        <button matButton="filled" class="actionbutton" (click)="createSchaltleitung()">
            <mat-icon>add</mat-icon>
            Neue Schaltleitung
        </button>
    </div>

    <table [dataSource]="schaltleitungenList"
           mat-table
           class="schaltleitungenTable"
           data-qa="settings-schaltleitungen-page-table">

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr style="cursor: pointer" mat-row *matRowDef="let schaltleitung; columns: columnsToDisplay"
            role="link"
            tabindex="0"
            (click)="openSchaltleitung(schaltleitung)"
            (keydown.enter)="openSchaltleitung(schaltleitung)"
        ></tr>

        <ng-container matColumnDef="kuerzel">
            <th mat-header-cell *matHeaderCellDef>Kürzel</th>
            <td mat-cell *matCellDef="let schaltleitung;">{{ schaltleitung.kuerzel }}</td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let schaltleitung;">{{ schaltleitung.name }}</td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef>E-Mail</th>
            <td mat-cell *matCellDef="let schaltleitung;">{{ schaltleitung.email }}</td>
        </ng-container>

        <ng-container matColumnDef="adresse">
            <th mat-header-cell *matHeaderCellDef>Adresse</th>
            <td mat-cell *matCellDef="let schaltleitung;">{{ schaltleitung.adresse }}</td>
        </ng-container>

        <ng-container matColumnDef="kontakte">
            <th mat-header-cell *matHeaderCellDef>Kontaktinformationen</th>
            <td mat-cell *matCellDef="let schaltleitung;">
                @for (kontakt of schaltleitung.kontakte; track kontakt) {
                    {{ kontakt.type }}{{ kontakt.type ? ':' : '' }} {{ kontakt.data }}<br/>
                }
            </td>
        </ng-container>

    </table>
</div>
